import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ModalService from 'services/ModalService';
import Button from 'components/Button/Button';
import ContentCard from 'components/ContentCard/ContentCard';
import Loading from 'components/Loading/Loading';
import Modal from 'components/Modal/Modal';

import styles from './style.css';


export const AdminBulkBanModal = (props) => {
  const { onConfirmPress, onCancelPress, fileName, step, setStep } = props;
  const [innerStep, setInnerStep] = useState(0);

  useEffect(() => {
    if (step === 2) {
      setInnerStep(2);
    }
  }, [step]);

  const onClickConfirmPress = useCallback(() => {
    onConfirmPress();
    setInnerStep(1);
  }, [onConfirmPress]);

  const onClickCancel = useCallback(() => {
    onCancelPress();
    setStep(0);
  }, [onCancelPress, setStep]);

  // eslint-disable-next-line react/no-multi-comp
  const renderModalContent = (currentStep) => {
    switch (currentStep) {
      case 0:
        return (
          <ContentCard
            className={styles.content}
            footer={
              <div>
                <Button
                  className={classNames(styles.cancelButton, styles.genericButton)}
                  colour="white"
                  onClick={onClickCancel}
                >
                  Cancel
                </Button>
                <Button
                  className={classNames(styles.confirmButton, styles.genericButton)}
                  colour="orange"
                  onClick={onClickConfirmPress}
                >
                  Yes
                </Button>
              </div>
            }
          >
            <p>{`You are about to ban all users defined in the following CSV file: ${fileName}`}</p>
            <p>Are you sure?</p>
          </ContentCard>
        );
      case 1:
        return (
          <ContentCard className={styles.contentLoading}>
            <p>Bulk Ban</p>
            <p>Bulk Ban operation is running…</p>
            <Loading />
          </ContentCard>
        );
      case 2:
        return (
          <ContentCard
            className={styles.contentLoading}
            footer={
              <Button
                className={classNames(styles.cancelButton, styles.singleBtn)}
                colour="white"
                onClick={onClickCancel}
              >
                CLOSE
              </Button>
            }
            footerClass={styles.footerModal}
          >
            <p>Bulk Ban</p>
            <p>Bulk Ban operation completed. Please view the results in the downloaded CSV file.</p>
          </ContentCard>
        );
      default:
        return null;
    }
  };

  return (
    <Modal close={ModalService.hideModal} showClose={innerStep !== 1} type="full">
      {renderModalContent(innerStep)}
    </Modal>
  );
};

AdminBulkBanModal.propTypes = {
  fileName: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  onCancelPress: PropTypes.func.isRequired,
  onConfirmPress: PropTypes.func.isRequired,
};

export default AdminBulkBanModal;
